export function getBankDetail(pan) {
    if (!pan || pan.length < 6) {
      return { name: "نامشخص", icon: 0, isExportBank: false };
    }
  
    const prefix = pan.substring(0, 6);
  
    switch (prefix) {
      case "603799": return { name: "بانک ملی", icon: "meli-bank-logo", isExportBank: false };
      case "589210":
      case "604932": return { name: "بانک سپه", icon: "sepah-bank-logo", isExportBank: false };
      case "627648":
      case "207177": return { name: "بانک توسعه صادرات", icon: "tosee-saderat-bank-logo", isExportBank: true };
      case "627961": return { name: "بانک صنعت و معدن", icon: "sanat-madan-bank-logo", isExportBank: false };
      case "603770":
      case "639217": return { name: "بانک کشاورزی", icon: "keshavarzi-bank-logo", isExportBank: false };
      case "628023": return { name: "بانک مسکن", icon: "maskan-bank-logo", isExportBank: false };
      case "627760": return { name: "پست بانک", icon: "post-bank-logo", isExportBank: false };
      case "502908":
      case "628157": return { name: "بانک توسعه تعاون", icon: "tosee-taavon-bank-logo", isExportBank: false };
      case "627412": return { name: "بانک اقتصاد نوین", icon: "eghtesad-novin-bank-logo", isExportBank: false };
      case "622106":
      case "639194": return { name: "بانک پارسیان", icon: "parsian-bank-logo", isExportBank: false };
      case "502229":
      case "639347": return { name: "بانک پاسارگاد", icon: "pasargad-bank-logo", isExportBank: false };
      case "627488":
      case "502910": return { name: "بانک کارآفرین", icon: "karafarin-bank-logo", isExportBank: false };
      case "621986": return { name: "بانک سامان", icon: "saman-bank-logo", isExportBank: false };
      case "639346": return { name: "بانک سینا", icon: "sina-bank-logo", isExportBank: false };
      case "639607": return { name: "بانک سرمایه", icon: "sarmayeh-bank-logo", isExportBank: false };
      case "636214":
      case "186214": return { name: "بانک آينده", icon: "ayandeh-bank-logo", isExportBank: false };
      case "502806":
      case "504706": return { name: "بانک شهر", icon: "shahr-bank-logo", isExportBank: false };
      case "502938": return { name: "بانک دی", icon: "dey-bank-logo", isExportBank: false };
      case "603769":
      case "622016": return { name: "بانک صادرات", icon: "saderat-bank-logo", isExportBank: true };
      case "610433": return { name: "بانک ملت", icon: "melat-bank-logo", isExportBank: false };
      case "627353":
      case "585983": return { name: "بانک تجارت", icon: "tejarat-bank-logo", isExportBank: false };
      case "589463": return { name: "بانک رفاه", icon: "refah-bank-logo", isExportBank: false };
      case "627381": return { name: "بانک انصار", icon: "sepah-bank-logo", isExportBank: false };
      case "639370": return { name: "بانک مهر اقتصاد", icon: "mehr-eghtesad-bank-logo", isExportBank: false };
      case "639599": return { name: "بانک قوامین", icon: "shahr-bank-logo", isExportBank: false };
      case "606373": return { name: "بانک قرض الحسنه مهر", icon: "mehr-iran-bank-logo", isExportBank: false };
      case "606256": return { name: "موسسه اعتباري ملل", icon: "melal-credit-institution-logo", isExportBank: false };
      case "636795": return { name: "بانك مركزي", icon: "markazi-bank-logo", isExportBank: false };
      case "581874": return { name: "بانک ايران و ونزوئلا", icon: "ic_bank_iran_venezuela", isExportBank: false };
      case "507677": return { name: "موسسه اعتباري نور", icon: "noor-bank-logo", isExportBank: false };
      case "505801": return { name: "موسسه اعتباري كوثر", icon: "kosar-bank-logo", isExportBank: false };
      case "504172": return { name: "بانک قرض الحسنه رسالت", icon: "resalat-bank-logo", isExportBank: false };
      case "505785": return { name: "بانک ايران زمين", icon: "iranzamin-bank-logo", isExportBank: true };
      case "585947":
      case "505809": return { name: "بانك خاورميانه", icon: "khavarmianeh-bank-logo", isExportBank: false };
      case "505416": return { name: "بانك گردشگري", icon: "gardeshgari-bank-logo", isExportBank: false };
      case "636949": return { name: "بانک حکمت ایرانیان", icon: "hekmat-iranian-bank-logo", isExportBank: false };
      default: return { name: "نامشخص", icon: 0, isExportBank: false };
    }
  }